<template>
    <div
        class="radioboxes"
        :class="{
            'radioboxes--small': small,
            'radioboxes--shadow': shadow,
            'radioboxes--vertical': vertical
        }"
    >
        <div class="radioboxes__list">
            <slot />
        </div>
    </div>
</template>

<script>
// @TODO adapt for FormField

export default {
    name: 'RadioBoxes',
    emits: ['update:modelValue'],
    props: {
        name: String,
        modelValue: {},
        small: Boolean,
        shadow: Boolean,
        vertical: Boolean
    },
    provide() {
        return {
            radioButtonState: this.radioButtonState,
            setValue: this.setValue
        };
    },
    data() {
        return {
            radioButtonState: {
                value: this.modelValue,
                inputName: this.name
            }
        };
    },
    watch: {
        modelValue() {
            this.radioButtonState.value = this.modelValue;
        }
    },
    methods: {
        setValue(value) {
            this.$emit('update:modelValue', value);
        }
    }
};
</script>

<style lang="scss" src="./RadioBoxes.scss"></style>
